import React from 'react'
import '../css/general/ResponseMsg.css';

const ResponseMsg = ({message, status}) => {
  return (
    <>
      <div className={`response-area py-2 px-2 animate__animated animate__fadeInDown animate__faster ${status === 'error' ? 'bg-danger' : 'bg-success'}`}>
        <p className='my-0'>{message}</p>
      </div>
    </>
  )
}

export default ResponseMsg
